// extracted by mini-css-extract-plugin
export default {"tagShortCode":"Tag_tagShortCode__2uHP5"};